import SamePage, {ConditionParams} from './_same-page';

export default function () {
    $(function () {
        /**
         * Client side show condition for SamePageItemValue elements.
         */
        $('.js-same-page-item-value').each(function () {
            const $targetElement = $(this); // Element to be shown or hidden
            const params = $(this).data('condition-params');

            SamePage.hideTargetElement($targetElement);
            if (isConditionTrue(params)) {
                SamePage.showTargetElement($targetElement);
            }
            // Change target element when source element changes

            // noinspection DuplicatedCode
            const $sourceElements = SamePage.getInputElementsByItemID(params.ItemID);
            $sourceElements.each(function () {
                const $sourceElement = $(this);
                $sourceElement.on('change', function () {
                    if (isConditionTrue(params)) {
                        SamePage.showTargetElement($targetElement);
                    } else {
                        SamePage.hideTargetElement($targetElement);
                        SamePage.resetInputField($targetElement); // Delete previously entered data
                    }
                });
            });
        });
    });
}

/**
 * @param params
 */
function isConditionTrue(params: ConditionParams): boolean {
    let result = false;
    // noinspection JSUnfilteredForInLoop,JSUnresolvedVariable
    const conditionItemID = params.ItemID;
    const $sourceElements = SamePage.getInputElementsByItemID(conditionItemID);
    $sourceElements.each(function () {
        if (SamePage.hasValue($(this)) && SamePage.conditionFunction(params, <string>$(this).val())) {
            result = true;
            return false; // Break each-loop
        }
    });
    return result;
}